export default __webpack_public_path__ + "favicons/apple-touch-icon.png";